import React from 'react';
import './CatererOptionCard.css';

const CatererOptionCard = ({
  selected = false,
  title,
  message,
  asset,
  onClick,     // Capital C
  onclick,     // lowercase c (for backward compatibility)
  available = true,
}) => {
  
  // Use onClick if provided, otherwise fall back to onclick
  const handleClickEvent = onClick || onclick;
  
  const handleClick = () => {
    console.log("CatererOptionCard clicked!");
    console.log("Available:", available);
    console.log("onClick exists:", !!handleClickEvent);
    
    if (available && handleClickEvent) {
      console.log("Calling onClick function...");
      handleClickEvent();
    } else if (!available) {
      console.log("Card is not available");
    }
  };
  
  return (
    <div 
      className={`caterer-option-card ${selected ? 'selected' : ''} ${!available ? 'unavailable' : ''}`}
      onClick={handleClick}
    >
      <div className="caterer-option-content">
        <div className="caterer-option-image">
          <img src={asset} alt={title} />
        </div>
        <div className="caterer-option-text">
          <h4 className="caterer-option-title">{title}</h4>
          <p className="caterer-option-message">{message}</p>
        </div>
        <div className="caterer-option-arrow">
          <span>→</span>
        </div>
      </div>
    </div>
  );
};

export default CatererOptionCard;